<article class="Notfound">
	<section class="Notfound__content">
		<img
			appImageBroken
			class="Notfound__image"
			src="assets/svgs/zee-products/vemo-logo.svg"
			alt="vemo logo in svg"
		/>
		<p class="Notfound__paragraph Margin-bottom--z">¡Oh, algo salió mal!</p>
		<p class="Notfound__paragraph Margin-bottom--l">
			No encontramos la ruta a la que intentas ingresar
		</p>
		<app-button isFull (clicked)="goBack()"> {{ buttonText() }} </app-button>
	</section>
</article>
